// 时间格式化为 mm:ss
export const formateTime = function (t) {
  if (!t) return '00:00'

  const fixBit = num => {
    if (num < 10) num = '0' + num
    return num
  }

  const s = parseInt(t / 1000)
  const second = s % 60
  const minute = parseInt(s / 60) % 60
  // const hour = parseInt(s / 3600)

  return fixBit(minute) + ':' + fixBit(second)
}

/**
 * 判断元素是否可见
 */
export const checkVisible = function (elm) {
  const rect = elm.getBoundingClientRect()
  // 获取当前浏览器的视口高度，不包括工具栏和滚动条
  // document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
  // bottom top是相对于视口的左上角位置
  // bottom大于0或者top-视口高度小于0可见
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0)
}

export const loadJs = function (url, options = {}) {
  const script = document.createElement('script')
  script.src = url

  for (let key in options) {
    script.setAttribute(key, options[key])
  }
  document.body.appendChild(script)
}

export const isProd = location.hostname === 'callai.net' || location.hostname === 'www.callai.net'
